export default {
  name: 'german-qwertz-1',
  lang: ['de'],
  normal: [
    'q w e r t z u i o p \u00fc',
    'a s d f g h j k l \u00f6 \u00e4',
    '{shift} y x c v b n m \u00df {bksp}',
    '{numbers} {space} . -',
  ],
  shift: [
    'Q W E R T Z U I O P \u00dc',
    'A S D F G H J K L \u00d6 \u00c4',
    '{shift} Y X C V B N M {bksp}',
    '{numbers} {space} . -',
  ],
  numbers: [
    '1 2 3 4 5 6 7 8 9 0',
    '~ ! @ # $ % ^ & * ( ) _ +',
    '| , . / : \u0022 \u005c {bksp}',
    '{numbers} {space} . -',
  ],
};
